import React from 'react';
import classNames from 'classnames';
import useMediaQuery from '../../hooks/useMediaQuery';
import style from './CardHighlighted.module.scss';

// eslint-disable-next-line react/prop-types, no-unused-vars
function CardHighlighted({ recipe, sale, news, classTitle }) {
    const isTablet = useMediaQuery('(min-width: 768px)');

    return (
        <div className={classNames(style['card-highlighted'], { [style.small]: classTitle && !isTablet }, { '--border': recipe || sale })}>
            {
                recipe &&
                <span className={style.recipe}>
                    За рецептом
                </span>
            }

            {/* {
                news &&
                <span className={style.news}>
                    Новинка
                </span>
            } */}

            {
                sale &&
                <div className={style.sale}>
                    <span>
                        Акція
                    </span>
                    <span>
                        -15%
                    </span>
                </div>
            }
        </div>
    );
}

export default CardHighlighted;
